/* esm.sh - @tiptap/extension-document@3.30.2 */
import{Node as n}from"@tiptap/core";var t=n.create({name:"doc",topNode:!0,content:"block+",renderMarkdown:(e,r)=>e.content?r.renderChildren(e.content,`

`):""}),d=t;export{t as Document,d as default};
//# sourceMappingURL=extension-document.mjs.map